module.exports = __webpack_public_path__ + "img/address.c7a35981.png";